import { RoleEnum } from '@zaoblako/shared/modules/security/enums/role.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';

import * as yup from 'yup';

/** Role response body */
export interface RoleFindInterface {
  /** Unique identifier */
  id: number;
  /** Display name */
  name: string;
  /** Role type */
  type: RoleEnum;
}

/** Role response body DTO schema */
export const RoleFindDto = SerdeDtoClass.create<RoleFindInterface>('security/role-find.dto', {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Название',
    serializer: yup.string(),
  },
  type: {
    label: 'Тип',
    serializer: yup
      .string()
      .oneOf(Object.values(RoleEnum)),
  },
})
